import 'es6-promise/auto'
import Vue from 'vue'
import Vuex from 'vuex'
import PrismicVue from 'prismic-vue'
import Meta from 'vue-meta';
import linkResolver from './prismic/link-resolver'
import htmlSerializer from './prismic/html-serializer'
import Transitions from 'vue2-transitions'
import App from './App.vue'
import router from './router'
import VueAnalytics from 'vue-analytics'
import store from './store.js'
import jQuery from 'jquery'
global.jQuery = jQuery
global.$ = jQuery
import moment from 'moment'
import MarqueeText from 'vue-marquee-text-component'
import VueScrollTo from 'vue-scrollto'
import VueLazyload from 'vue-lazyload'

let performa = require('./assets/js/performa.js')

Vue.config.productionTip = false

Vue.component('marquee-text', MarqueeText)

Vue.use(
	PrismicVue, {
	  endpoint: window.prismic.endpoint,
	  linkResolver,
	  htmlSerializer
	}
)
Vue.use(Meta)
Vue.use(Transitions)
Vue.use(VueScrollTo, {
	container: "#app",
	duration: 500,
	easing: "ease",
	offset: 0,
	force: true,
	cancelable: true,
	onStart: false,
	onDone: false,
	onCancel: false,
	x: false,
	y: true
})

Vue.use(VueLazyload, {
  preLoad: 0.667,
  attempt: 1
})

Vue.use(VueAnalytics, {
  id: 'UA-25214895-1',
  router
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')